
import { defineComponent } from "vue";
import KTTopbar from "@/layout/header/Topbar.vue";
import KTMenu from "@/layout/header/Menu.vue";
import { version } from "@/core/helpers/documentation";
import { isDocPage } from "@/core/helpers/documentation";
import {getAvailablePCPForRepositionCount}  from "@/api/pcp";

import {
  headerWidthFluid,
  headerLeft,
  asideDisplay
} from "@/core/helpers/config";

export default defineComponent({
  name: "KTHeader",
  props: {
    title: String
  },
  components: {
    KTTopbar,
    KTMenu
  },
  methods: {
    async getAvailablePCPForRepositionCountFN(){ 
      const response = await getAvailablePCPForRepositionCount();
      this.repositionCount = response.data.repositionCount;
    },
  },
  setup() {
    return {
      isDocPage,
      headerWidthFluid,
      headerLeft,
      asideDisplay,
      version
    };
  },
  data() {
    return {
      repositionCount : 0 as number
    };
  },
  mounted() {
    this.getAvailablePCPForRepositionCountFN();
  }
});
